<template>
  <div class="tips-wrap">
    <el-checkbox
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.agreement`,
      }"
      class="checkbox-custom"
      :class="[singleStatus ? configStyle : '']"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <div class="tips-text" :class="[singleStatus ? configStyle : '']">
      <span>{{ agreeReadPreText }}</span>
      <a
        class="a-custom"
        :href="getLang('terms')"
        target="_blank"
        v-track="{ type: 'click', name: `form.terms_details` }"
      >
        {{ $t('login.register.termsName') }}
      </a>
      <span :class="{}">{{ agreeAnd }}</span>
      <a
        class="a-custom"
        :href="getLang('privacy')"
        target="_blank"
        v-track="{ type: 'click', name: 'form.privacy_details' }"
      >
        {{ $t('login.register.privacyPolicyName') }}
      </a>
      <span v-if="!isNissan">{{ $i18n.locale === 'cn' ? '。' : '.' }}</span>
    </div>
  </div>
</template>
<script>
import gotinAddress from '@/constant'
import { getLang } from '@/utils/storage.js'
import { getBusinessType } from '@/constant'

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      gsmaConfig: {
        // 用户协议：
        termsen: 'https://mymwc-login.gotin.online/termsen',
        termscn: 'https://mymwc-login.gotin.online/termscn',

        // 隐私条款：
        privacy: 'https://mymwc-login.gotin.online/privacyen',
      },
      // getLang: gotinAddress,
    }
  },
  computed: {
    singleStatus() {
      return getBusinessType().hasOwnThemeStyle
    },
    configStyle() {
      return getBusinessType().className
    },
    agreeReadPreText() {
      return getBusinessType().agreeReadPreText
    },
    agreeAnd() {
      return getBusinessType().agreeAnd
    },
    isNissan() {
      return getBusinessType().id === 'nissan'
    },
    isAiahrn() {
      return getBusinessType().id === 'aiahrn'
    },
  },
  methods: {
    getLang(param) {
      if (this.isAiahrn) {
        if (param == 'terms') {
          return '/term&agreement/aia-hrn/使用条款.html'
        } else {
          return '/term&agreement/aia-hrn/隐私政策.html'
        }
      } else if (
        this.$route.query.event_id !== 'QMVR3YN9XX8Xjvkg' &&
        this.$route.query.event_id !== 'O9rgdawJQdGE1PRL' &&
        !this.isNissan
      ) {
        return gotinAddress(param)
      } else if (this.isNissan) {
        return process.env.VUE_APP_NISSAN_TERMS + param + '.html'
      } else if (param == 'terms') {
        return this.gsmaConfig[param + getLang().toString()]
      } else {
        return this.gsmaConfig[param]
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.tips-wrap {
  display: flex;
  margin-bottom: 12px;
  margin-top: 28px;
}

.zlzp-agreement {
  margin-top: unset;
  margin-bottom: 8px;

  .zlzp-wrap {
    color: #737278;

    a {
      color: #fe1000;
    }
  }
}

.checkbox-custom {
  height: 22px;
  margin-right: 12px;
}

.tips-text {
  color: #5c5c5c;
  font-size: 14px;
  line-height: 22px;
}

.porsche-wrap {
  color: #737278;

  .a-custom {
    color: #d5001c;
  }
}

.porsche911-wrap {
  color: #737278;

  .a-custom {
    color: #d5001c;
  }
}

.porschetaycan-wrap {
  color: #737278;

  .a-custom {
    color: #d5001c;
  }
}

.aia-wrap {
  font-family: 'HYQiHei';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);

  .a-custom {
    color: #f63b6d;
  }
}

.takedaspark-wrap {
  .a-custom {
    color: rgba(197, 40, 6, 1);
  }
}
</style>
<style lang="scss">
.takedaspark-wrap.el-checkbox {
  .el-checkbox__input {
    &.is-checked .el-checkbox__inner {
      background: linear-gradient(90.61deg, #c52805 20.53%, #de6635 98.65%);
      border-color: linear-gradient(90.61deg, #c52805 20.53%, #de6635 98.65%);
    }
  }
}

.nissan-wrap.el-checkbox {
  margin-right: 6px;

  .el-checkbox__inner {
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border-color: transparent;
    width: 24px;
    height: 24px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: rgba(0, 0, 0, 0.3);
    border-color: transparent;
  }
}

.tips-text.nissan-wrap {
  font-size: 12px;
  color: #fff;

  .a-custom {
    color: #ff99f4;
  }
}
</style>
